import {
  CHANGE_SELECTED_ROLE,
  UPDATE_SELECTED_ROLE,
  RESET_SELECTED_USER,
  RESET_SELECTED_ROLE,
  UPDATE_SELECTED_USER,
  CHANGE_SELECTED_USER,
  POST_USER,
  POST_USER_START,
  POST_USER_SUCCESS,
  POST_USER_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const resetSelectedUser = () => ({ type: RESET_SELECTED_USER })
const resetSelectedRole = () => ({ type: RESET_SELECTED_ROLE })
const updateSelectedUser = (username) => ({ type: UPDATE_SELECTED_USER, username })
const changeSelectedUser = (user) => ({ type: CHANGE_SELECTED_USER, user })
const updateSelectedRole = (role) => ({ type: UPDATE_SELECTED_ROLE, role })
const changeSelectedRole = (role) => ({ type: CHANGE_SELECTED_ROLE, role })
const postUser = () => ({ type: POST_USER })
const postUserStart = () => ({ type: POST_USER_START })
const postUserSuccess = () => ({ type: POST_USER_SUCCESS })
const postUserError = (error) => ({ type: POST_USER_ERROR, error })
const startPostUserAsync = buildAsyncAction(
  POST_USER,
  POST_USER_START,
  [POST_USER_SUCCESS, POST_USER_ERROR]
)

export {
  resetSelectedUser,
  resetSelectedRole,
  updateSelectedUser,
  changeSelectedUser,
  updateSelectedRole,
  changeSelectedRole,
  postUser,
  postUserStart,
  postUserSuccess,
  postUserError,
  startPostUserAsync,
}
